import React from 'react';
import { Shield, Clock, Award, Star, Users, Globe, Heart, Zap, CheckCircle, Phone } from 'lucide-react';
import { contactInfo } from '../data/mock';

const WhyChooseSection = () => {
  const reasons = [
    {
      icon: Award,
      title: "30 Ans d'Expérience",
      description: "Le grand marabout africain pratique les arts mystiques depuis plus de 30 ans. Son savoir ancestral transmis de génération en génération garantit des résultats exceptionnels pour votre retour affectif."
    },
    {
      icon: Users,
      title: "Plus de 290 Clients Satisfaits",
      description: "Des milliers de couples réunis grâce aux rituels puissants du spécialiste du retour affectif. Témoignages vérifiés de France, Belgique, Suisse, Canada et du monde entier."
    },
    {
      icon: Clock,
      title: "Résultats en 24 à 72 Heures",
      description: "Les rituels de retour affectif du grand marabout agissent rapidement. La plupart des clients voient leur ex revenir dans les 24 à 72 heures suivant l'intervention."
    },
    {
      icon: Globe,
      title: "Intervention Mondiale",
      description: "Le marabout africain intervient partout dans le monde : France, Belgique, Suisse, Canada, Afrique, DOM-TOM. Les rituels à distance sont tout aussi efficaces."
    },
    {
      icon: Shield,
      title: "Confidentialité Absolue",
      description: "Votre vie privée est sacrée. Le spécialiste garantit une discrétion totale sur votre situation. Aucune information n'est jamais divulguée."
    },
    {
      icon: Zap,
      title: "Rituels Puissants et Efficaces",
      description: "Le grand marabout maîtrise les trois formes de magie : blanche, noire et rouge. Il choisit la technique la plus adaptée à votre cas."
    }
  ];

  const stats = [
    { number: "290+", label: "Clients satisfaits" },
    { number: "30+", label: "Années d'expérience" },
    { number: "98%", label: "Taux de réussite" },
    { number: "24-72h", label: "Délai de résultats" }
  ];

  return (
    <section className="py-16 sm:py-28 bg-black relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 right-0 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 left-0 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-20">
          <span className="inline-block px-4 sm:px-5 py-2 bg-amber-500/10 border border-amber-500/30 rounded-full text-amber-500 text-xs sm:text-sm font-semibold tracking-wide mb-4 sm:mb-6">
            Pourquoi le Grand Marabout ?
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-8 px-2">
            Le <span className="text-amber-500">Meilleur Marabout</span> pour votre Retour Affectif
          </h2>
          <p className="text-gray-300 text-base sm:text-xl max-w-4xl mx-auto leading-relaxed px-2">
            Le grand marabout africain est reconnu comme l'un des meilleurs spécialistes du retour affectif. 
            Son expertise, sa puissance et son sérieux font de lui le choix numéro 1 pour récupérer votre ex.
          </p>
        </div>

        {/* Stats Bar */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8 mb-16 sm:mb-24">
          {stats.map((stat, index) => (
            <div key={index} className="text-center p-6 sm:p-8 bg-gray-900/50 border border-amber-500/20 rounded-2xl">
              <div className="text-3xl sm:text-5xl font-extrabold text-amber-500 mb-2">{stat.number}</div>
              <div className="text-gray-400 text-sm sm:text-base font-medium">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Reasons Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {reasons.map((reason, index) => (
            <article key={index} className="bg-gray-900/50 border border-amber-500/10 rounded-2xl p-6 sm:p-8 hover:border-amber-500/30 transition-all duration-300">
              <div className="w-14 h-14 bg-amber-500/10 rounded-xl flex items-center justify-center mb-6">
                <reason.icon className="w-7 h-7 text-amber-500" />
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">{reason.title}</h3>
              <p className="text-gray-400 text-sm sm:text-base leading-relaxed">{reason.description}</p>
            </article>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <p className="text-gray-300 text-lg mb-6">Ne perdez plus de temps, récupérez votre ex maintenant</p>
          <a
            href={contactInfo.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-8 py-5 bg-amber-500 text-black font-bold text-lg rounded-full hover:bg-amber-400 transition-all duration-300 hover:scale-105"
          >
            <Phone className="w-5 h-5 mr-3" />
            Contactez le marabout : {contactInfo.phone}
          </a>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
